import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-form-prompt-dialog',
  templateUrl: './form-prompt-dialog.component.html',
  styleUrls: ['./form-prompt-dialog.component.scss'],
})
export class FormPromptDialogComponent {
  @Input() status: string;
  @Input() header: string;
  @Input() body: string;
  @Input() btn_confirm_name: string = 'Confirm';
  @Input() btn_cancel_name: string = 'Close';
  @Input() show_cancel_button: boolean = true;
  @Input() show_confirm_btn: boolean = true;

  formCustom: FormGroup;

  constructor(protected ref: NbDialogRef<FormPromptDialogComponent>) {}

  setIcon(status) {
    if (status === 'danger') {
      return 'close-circle-outline';
    } else if (status === 'warning') {
      return 'alert-circle-outline';
    } else if (status === 'info') {
      return 'info-outline';
    } else if (status == 'success') {
      return 'checkmark-circle-2-outline';
    } else {
      return 'info-outline';
    }
  }

  dismiss() {
    this.ref.close({ event: false });
  }

  confirm() {
    this.ref.close({ event: true });
  }
}
